import React from 'react';
import { EnergyDirection } from '../style';
import { calculateEnergyDirectionArrowProps } from '../helpers/hierarchy';

function EnergyDirectionArrow(props) {
  const { connection, connection: { energy: { direction } = {} } = {}, showEnergyFlow } = props;

  if (!showEnergyFlow || !direction || direction === 'UNSPECIFIED') return null;

  const { x, y, angle } = calculateEnergyDirectionArrowProps(connection);

  return (
    <EnergyDirection x={x} y={y} direction={direction}>
      <g transform={`rotate(${angle}, 0, 0)`}>
        <path d="M -11 -12 L 0 0 L 11 -12" />
        <path d="M -11 -5 L 0 7 L 11 -5" />
        <path d="M -11 2 L 0 14 L 11 2" />
      </g>
    </EnergyDirection>
  );
}

export default EnergyDirectionArrow;
